<template>
  <div class="wrapper">
    <div class="inner">
      <RegistrationHeader />
      <main>
        <section class="content">
          <Nuxt />
        </section>
      </main>
      <RegistrationFooter />
    </div>
    <ExternalIntegrations />
  </div>
</template>
<script>
import { isNoindexNofollow } from '@/helpers/pageData'
import getCanonical from '@/helpers/getCanonical'
import ExternalIntegrations from '~/components/Common/ExternalIntegrations/ExternalIntegrations.vue'
import EventBus from '~/mixins/EventBus'
import RegistrationHeader from '@/components/NewDesign/Layout/Registration/Header/RegistrationHeader.vue'
import RegistrationFooter from '@/components/NewDesign/Layout/Registration/Footer/RegistrationFooter.vue'

export default {
  components: {
    RegistrationFooter,
    RegistrationHeader,
    ExternalIntegrations,
  },
  mixins: [EventBus],
  head() {
    return {
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        {
          innerHTML: JSON.stringify(this.generateLdPlusJSON()),
          type: 'application/ld+json',
        },
      ],
      link: [
        {
          rel: 'canonical',
          href: getCanonical(this.$route.path),
        },
      ],
      meta: [
        ...(isNoindexNofollow(this.$route.path)
          ? [{ name: 'robots', content: 'noindex, nofollow' }]
          : []),
      ],
    }
  },
  methods: {
    generateLdPlusJSON() {
      return {
        '@context': 'http://schema.org',
        '@type': 'Organization',
        name: 'МТС Линк',
        alternateName: 'МТС Линк',
        url: 'https://mts-link.ru' + this.$route.path,
        logo: 'https://mts-link.ru/_nuxt/img/mts-link.svg',
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.wrapper {
  display: flex;
  justify-content: center;
  min-height: 100vh;
  width: 100%;
  padding: 32px;
  overflow: hidden;
  background: linear-gradient(180deg, #e4ddd6 0%, #cec7c0 100%);

  @include screen-down('md') {
    padding: 64px 20px 20px;
  }

  .inner {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }

  .content {
    max-width: 600px;
    height: 100%;
    margin: 0 auto;

    @include screen-down('md') {
      max-width: 335px;
    }
  }
}
</style>
